module.exports = __webpack_public_path__ + "assets/img/sea5.c3711ada.png";